import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
const removeWalletConnectFromErrorString = (message) => message
    .replaceAll('WalletConnect', '')
    .replaceAll('WalletConnect', '')
    .replaceAll('WalletConnect:', '');
export class WalletConnectException extends ConcreteException {
    static errorClass = 'WalletConnectException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using WalletConnect');
        }
        else {
            this.setMessage(mapErrorMessage(removeWalletConnectFromErrorString(message)));
        }
        this.setName(WalletConnectException.errorClass);
    }
}
